export function TimerIcon({ fill = 'white' }: { fill?: string }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M9 10.3125C8.6925 10.3125 8.4375 10.0575 8.4375 9.75V6C8.4375 5.6925 8.6925 5.4375 9 5.4375C9.3075 5.4375 9.5625 5.6925 9.5625 6V9.75C9.5625 10.0575 9.3075 10.3125 9 10.3125Z"
        fill={fill}
      />
      <path
        d="M9 17.0625C5.07 17.0625 1.875 13.8675 1.875 9.9375C1.875 6.0075 5.07 2.8125 9 2.8125C12.93 2.8125 16.125 6.0075 16.125 9.9375C16.125 10.245 15.87 10.5 15.5625 10.5C15.255 10.5 15 10.245 15 9.9375C15 6.63 12.3075 3.9375 9 3.9375C5.6925 3.9375 3 6.63 3 9.9375C3 13.245 5.6925 15.9375 9 15.9375C9.3075 15.9375 9.5625 16.1925 9.5625 16.5C9.5625 16.8075 9.3075 17.0625 9 17.0625Z"
        fill={fill}
      />
      <path
        d="M11.25 2.0625H6.75C6.4425 2.0625 6.1875 1.8075 6.1875 1.5C6.1875 1.1925 6.4425 0.9375 6.75 0.9375H11.25C11.5575 0.9375 11.8125 1.1925 11.8125 1.5C11.8125 1.8075 11.5575 2.0625 11.25 2.0625Z"
        fill={fill}
      />
      <path
        d="M12.1094 16.5151C11.8469 16.5151 11.6069 16.4551 11.3894 16.3276C10.8944 16.0426 10.6094 15.4651 10.6094 14.7451V13.0126C10.6094 12.2926 10.8944 11.7151 11.3894 11.4301C11.8844 11.1451 12.5219 11.1901 13.1444 11.5426L14.6444 12.4126C15.2669 12.7726 15.6269 13.3051 15.6269 13.8751C15.6269 14.4451 15.2669 14.9776 14.6444 15.3376L13.1444 16.2076C12.7994 16.4101 12.4469 16.5151 12.1094 16.5151ZM12.1169 12.3601C12.0569 12.3601 11.9969 12.3751 11.9519 12.3976C11.8169 12.4726 11.7344 12.7051 11.7344 13.0051V14.7376C11.7344 15.0376 11.8169 15.2701 11.9519 15.3451C12.0869 15.4201 12.3269 15.3826 12.5819 15.2326L14.0819 14.3626C14.3444 14.2126 14.5019 14.0251 14.5019 13.8751C14.5019 13.7251 14.3444 13.5376 14.0819 13.3876L12.5819 12.5176C12.4094 12.4126 12.2444 12.3601 12.1169 12.3601Z"
        fill={fill}
      />
    </svg>
  );
}

export default TimerIcon;
